// extracted by mini-css-extract-plugin
module.exports = {"login":"Login_login__2EBTr","inner":"Login_inner__oXueg","logo":"Login_logo__37TxX","card":"Login_card__23pqm","form":"Login_form__3_BEW"};